import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import api from "../../../api/Api.js";
import { Link, redirect, useNavigate } from "react-router-dom";
import { ArrowLeft,Search } from "lucide-react";
import Swal from "sweetalert2";

const CountryManage = () => {

  const navigate = useNavigate();
const [searchTerm, setSearchTerm] = useState("");
  const [Countrys, setCountrys] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(10);

  // =========================
  // FETCH Country DATA
  // =========================

  useEffect(() => {
    fetchCountryData();
  }, []);

  const fetchCountryData = async () => {
    try {
      const res = await api.get("/adminHolidays/get-holidays-country-data");
      setCountrys(res.data?.data || []);
    } catch (error) {
      toast.error("Failed to load Country data");
    }
  };

  // =========================
  // DELETE Country
  // =========================

  const handleDelete = async (id) => {

    const confirm = await Swal.fire({
      title: "Delete Country?",
      text: "Do you want to delete this Country?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes Delete"
    });

    if (!confirm.isConfirmed) return;

    try {

      const res = await api.delete(
        `/adminHolidays/holidays-country-delete/${id}`
      );

      if (res.data.success) {
        Swal.fire("Deleted!", "Country deleted successfully", "success");
        fetchCountryData();
      }

    } catch (error) {
      toast.error("Failed to delete Country");
    }

  };

  // =========================
  // STATUS CHANGE
  // =========================

  const handleStatusChange = async (id, status) => {

    try {

      await api.put("/adminHolidays/holidays-country-status", {
        id,
        status
      });

      toast.success("Status updated");
      fetchCountryData();

    } catch (error) {
      toast.error("Failed to update status");
    }

  };



const handleEditCountry = (countryId) => {
  navigate(`/holidays/country/edit-country/${countryId}`);
};

  // =========================
  // PAGINATION
  // =========================

  // const indexOfLast = currentPage * perPage;
  // const indexOfFirst = indexOfLast - perPage;
  // const currentItems = Countrys.slice(indexOfFirst, indexOfLast);
  // const totalPages = Math.ceil(Countrys.length / perPage);



   // =========================
  // FILTER & SEARCH
  // =========================
  const filteredCountries = Countrys.filter((cat) => {
    const term = searchTerm.trim().toLowerCase();

    const countryName = String(cat.name || "").toLowerCase();
    const countrySlug = String(cat.slug || "").toLowerCase();

    return (
      countryName.includes(term) ||
      countrySlug.includes(term)
    );
  });

  // =========================
  // PAGINATION
  // =========================
  const totalPages = Math.ceil(filteredCountries.length / perPage);

  const indexOfLast = currentPage * perPage;
  const indexOfFirst = indexOfLast - perPage;

  const currentItems = filteredCountries.slice(
    indexOfFirst,
    indexOfLast
  );

  // Search change hone par first page par jaayein
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };


const handleViewDetails = (cat) => {
  const PATRATARAVELS_URL = process.env.REACT_APP_PATRATARAVELS_URL;

  const baseUrl = `${PATRATARAVELS_URL}/holidays/`;

  const packageType = cat.package_id_master;
  const packageSlug = cat.slug;

  const url = `${baseUrl}${packageType}/country/${packageSlug}`;

  window.open(url, "_blank", "noopener,noreferrer");
};


  // =========================
  // JSX
  // =========================

  return (
    <div className="container-fluid py-3 bg-white min-vh-100">

      {/* HEADER */}
      <div className="card shadow-sm border-0 mb-4 bg-primary-subtle rounded-3">
        <div className="card-body d-flex justify-content-between">
          <h4 className="fw-bold">Holidays Manage Country</h4>
<div style={{display:"flex"}}>
<div className="input-group input-group-sm" style={{width: '200px',marginRight:"10px"}}>
                <span className="input-group-text bg-white"><Search size={16}/></span>
                <input 
                  type="text" 
                  className="form-control" 
                  placeholder="Search..." 
                  value={searchTerm} 
                  onChange={handleSearch}
                />
</div>
          <Link
            to={"/holidays/country/add-country"}
            className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2"
          >
            <ArrowLeft size={16} /> Add Holidays Country
          </Link>
          </div>
        </div>
      </div>

      {/* TABLE */}
      <div className="card shadow-sm border-0">
        <div className="table-responsive">

          <table className="table table-hover table-sm align-middle mb-0">

            <thead className="bg-light">
              <tr>
                <th>Sl</th>
                <th>Country Name</th>
                <th>Slug</th>
                <th className="d-none">View</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>

              {currentItems.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center py-4 text-muted">
                    No Country Found
                  </td>
                </tr>
              ) : (

                currentItems.map((cat, index) => (

                  <tr key={cat.cntry_id}>

                    <td>{indexOfFirst + index + 1}</td>

                    <td>{cat.name}</td>

                    <td>{cat.slug}</td>
                    <td className="text-center d-none" >
  {cat.status == 1 ? (
    <button
      type="button"
      className="btn btn-sm btn-success"
      onClick={() => handleViewDetails(cat)}
      title="View Details"
    >
      <i className="fa fa-eye" aria-hidden="true"></i>
    </button>
  ) : (
    <span className="text-danger">
      Inactive
    </span>
  )}
</td>

                    {/* STATUS */}
                 <td>
 {!cat.meta_title ? (
    <span style={{color:"red",fontSize:"14px"}}>Update Country SEO Details</span>
  ) : (
    <select
      className={`form-select form-select-sm ${
        cat.status == 1 ? "text-success" : "text-danger"
      }`}
      value={cat.status}
      onChange={(e) =>
        handleStatusChange(cat.cntry_id, e.target.value)
      }
    >
      <option value="1">Active</option>
      <option value="0">Inactive</option>
    </select>
  )}
</td>

                    {/* ACTION */}
                    <td>
                      <button
                        className="btn btn-sm btn-primary me-2"
                        onClick={() => handleEditCountry(cat.cntry_id)}
                      >
                        <i className="fa fa-pencil"></i>
                      </button>

                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDelete(cat.cntry_id)}
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </td>

                  </tr>

                ))

              )}

            </tbody>

          </table>

        </div>

        {/* PAGINATION */}
        <div className="d-flex justify-content-center mt-3">
          <ul className="pagination">

            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>
                Prev
              </button>
            </li>

            {Array.from({ length: totalPages }, (_, i) => (
              <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
                <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
                  {i + 1}
                </button>
              </li>
            ))}

            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>
                Next
              </button>
            </li>

          </ul>
        </div>

      </div>

    </div>
  );
};

export default CountryManage;